import queryString from 'query-string';
import { apiGET } from './api';

export const getTaxDocuments = (params) => apiGET(`/tax_documents?${queryString.stringify(params)}`);

export const downloadTaxDocument = (foodDonorId, year) => apiGET(`/tax_documents/${foodDonorId}/${year}/download`);
